<template>
  <v-list three-line dense nav class="px-0 pt-0 full-width">
    <v-list-item v-if="documents.length === 0">
      <div class="pa-4 caption" style="font-size: 1em">{{ $t('fd.noDocuments') }}</div>
    </v-list-item>

    <!-- :additionalText="`'priority=${doc.priority} sort=${doc.sort}`" -->

    <base-list-item
      v-for="(doc, ind) in sortedDocuments"
      :key="`${ind}_${doc.id}`"
      :id="`f_${doc.id}`"
      :file="doc"
      :ignoreReadState="ignoreReadState"
      :updateCount="updateCount"
      :longClickEnabled="true"
      :isSelected="selectedItem && selectedItem.id === doc.id"
      :markAsReadOnSelect="markAsReadOnSelect"
      @onSelected="onSelected(doc)"
    >
      <slot v-if="doc.kurs" name="customRow">
        <span v-for="kurs in kursList(doc)" :key="kurs" :class="`tag mx-2 px-2 ${theme.accent}`">Kurs {{ kurs }}</span>
      </slot>
    </base-list-item>
  </v-list>
</template>

<script>
import common from '@/mixins/common';
import BaseListItem from '@/components/listItems/BaseListItem.vue';
import sortFunctions from '@/sorters/sortFunctions';
export default {
  name: 'FahrdienstDocList',
  mixins: [common],
  props: {
    title: String,
    documents: Array,
    selectedDocument: Object,
    sorterName: { type: String, default: 'byImportance' },
    updateRequired: Boolean,
    ignoreReadState: { type: Boolean, default: false }, // true to not display unread, confirm and mandatory to read markers
    updateCount: Number, // This is an indicator to make sure files are updated. It might be necessary to work-around broken reactivity chain. See
    // Fahrdienst.vue, FahrdienstHeader, FavoriteIcon
    markAsReadOnSelect: { type: Boolean, default: true },
  },
  components: { BaseListItem },
  mounted() {
    this.sortedDocuments = this.sortDocuments();
  },
  data() {
    return {
      selectedItem: this.selectedDocument,
      sortedDocuments: [],
    };
  },
  methods: {
    sortDocuments() {
      return this.documents ? sortFunctions.sortBySorter(this.documents, this.sorterName) : [];
    },
    onSelected(doc) {
      console.debug('document selected', doc);
      this.$emit('onSelected', doc);
    },

    kursList(doc) {
      if (doc.kurs) {
        let kurse = doc.kurs
          .split(',')
          .sort((a, b) => Number(a) - Number(b))
          .slice(0, 3);
        return kurse;
      }
      return [];
    },
  },
  watch: {
    updateCount: {
      handler(newValue) {
        console.debug('changesCount =', newValue);
      },
      deep: true,
      immediate: true,
    },

    selectedDocument(newValue) {
      this.selectedItem = newValue;
    },
    documents(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.sortedDocuments = this.sortDocuments();
      }
    },
    sorterName(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.sortedDocuments = this.sortDocuments();
      }
    },
  },
};
</script>
